import styled from 'styled-components'
import { BLUE_PRINCIPAL, GREEN, GREY, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const Container = styled.ul`
  border-bottom: 1px solid ${GREY};
  position: relative;
  display: flex;
  align-items: flex-end;
  width: calc(100% - 6px);
  white-space: nowrap;

  @media (max-width: ${MD}) {
    overflow-y: hidden;
    overflow-x: auto;
  }

  li {
    background-color: ${WHITE};
    margin-right: 8px;
    border-radius: 10px 10px 0px 0px;
    font-family: Mont, sans-serif;
    font-weight: 700;
    font-size: 14px;
    border: 1px solid ${GREY};
    border-bottom: none;
    line-height: 20px;
    color: ${BLUE_PRINCIPAL};
    padding: 18px 24px;
    padding-bottom: 8px;
    position: relative;
    cursor: pointer;

    .tabbar_content {
      white-space: nowrap;
    }

    &:hover {
      padding-bottom: 16px;
    }

    &.active {
      bottom: -1px;
      padding-bottom: 22px;
      color: ${GREEN};
      .icon svg {
        fill: ${GREEN};
      }
    }

    .icon {
      display: inline-block;
      vertical-align: middle;
      width: 23px;
      height: 23px;
      margin-right: 6px;

      img, svg {
        fill: ${BLUE_PRINCIPAL};
        width: 100%;
        height: 100%;
      }
    }
  }
`
